// Every word the player can read, in German.
//
// A translation of en.js and nothing else: the same keys in the same order, so the two files can
// be read side by side — and so a key added to the original is a key missing here, which is
// something a diff can see. i18n.js falls back to English for anything this file has not filled
// in, so a gap here shows English rather than a blank or a raw key name.

export default {
  // --- chrome --------------------------------------------------------------
  // La descripción que sale en Google y al pegar el enlace en un chat. Vive aquí y no escrita
  // en el HTML porque el HTML se genera por idioma en el build (ver tools/prerender-langs.mjs).
  'seo.description': 'Das klassische Bananenwurfspiel, neu gebaut und mehrspielerfähig: Rundenartillerie über einer Neon-Skyline. Gegen die CPU, an einer Tastatur oder per Code. Kostenlos und in sechs Sprachen.',
  'app.tagline': 'Das klassische Bananenwurfspiel — neu gebaut und mit Mehrspieler.',
  'app.footer': 'Gemacht von Mendo Network, mit Liebe und viel Nostalgie.',
  'ad.label': 'Werbung',
  'ad.tag': 'WERBUNG',
  'app.canvasLabel': 'Schlachtfeld: Neon-Skyline mit zwei Gorillas, die Bananen werfen',
  'app.language': 'SPRACHE',

  'title.start': '▶ JETZT SPIELEN',
  'title.join': '▶ BEITRETEN',

  'menu.title': 'HAUPTMENÜ',
  'menu.resume': '▶ ZURÜCK ZUM SPIEL',
  'menu.newMatch': '▶ NEUES SPIEL',
  'menu.play': '▶ NEUES SPIEL',
  'menu.characters': '🎨 FIGUR',
  'menu.leaderboards': '🏆 BESTENLISTEN',
  'menu.back': '← ZURÜCK ZUM START',
  'menu.awards': '🏆 ERFOLGE',

  'setup.title': 'SPIELEINSTELLUNGEN',
  'setup.mode': 'MODUS',
  'setup.players': 'SPIELER',
  'setup.turn': 'ZUGZEIT',
  'setup.noLimit': 'OHNE LIMIT',
  'setup.target': 'SPIELRUNDEN',
  'setup.onePlayer': '🤖 1 SPIELER',
  'setup.twoPlayers': '👥 2 SPIELER',
  'setup.back': '← ZURÜCK',
  'setup.start': '▶ SPIEL STARTEN',

  'pause.title': 'PAUSE',
  'pause.turn': '{name} IST DRAN',
  'pause.resume': '▶ WEITER',
  'pause.restart': '↻ NEU STARTEN',
  'pause.setup': '🎮 EINSTELLUNGEN',
  'pause.share': '🔗 EINLADEN',
  'pause.home': '🚪 SPIEL BEENDEN',
  'pause.menu': '⌂ ZURÜCK ZUM HAUPTMENÜ',
  'pause.music': 'MUSIK',
  'pause.fx': 'EFFEKTE',
  'setup.against': 'DIE GEGENSEITE',
  'setup.againstCpu': '🤖 DIE CPU',
  'setup.againstRandom': '🎲 ZUFALLSGEGNER',
  'pool.waiting': '{n} WARTEN',
  'pool.playing': '{n} SPIELEN · {w} WARTEN',
  'pool.none': 'GERADE WARTET NIEMAND',
  'pool.noserver': 'KEIN SERVER · DU SPIELST GEGEN DIE CPU',
  'search.title': 'GEGNER WIRD GESUCHT',
  'search.empty': 'DIE SCHLANGE IST LEER · DU SPIELST GEGEN DIE CPU',
  'search.seconds': '{n} s',
  'search.matched': '{name} IST DA',
  'search.cpu': '🤖 GEGEN DIE CPU',
  'search.cancel': '✖ ABBRECHEN',
  'special.sheep.name': 'SCHAF',
  'special.sheep.hint': 'Hüpft von selbst und knallt.',
  'play.fireSheep': '🐑 SCHAF!',
  'bubble.sheep': 'MÄÄÄH!',
  'char.you': 'DU',
  'char.rival': 'GEGNER',
  'hud.vsOnline': 'VS {name}',
  'music.on': 'MUSIK AN',
  'music.off': 'MUSIK AUS',
  'pause.button': 'Pause',

  'results.over': 'SPIEL VORBEI',
  'results.wins': '{name} GEWINNT',
  'results.rematch': '▶ REVANCHE',

  // --- the header and the play bar ----------------------------------------
  'hud.vsCpu': 'VS CPU',
  'hud.twoPlayer': '2 SPIELER',
  'hud.firstTo': 'BIS',
  'hud.round': 'RUNDE {n}',
  'hud.noRound': 'RUNDE —',
  'hud.p1': 'S1',
  'hud.p2': 'S2',
  'hud.cpu': 'CPU',
  'hud.wind': 'WIND',

  'play.angle': 'WINKEL',
  'play.power': 'KRAFT',
  'play.fire': 'WERFEN',
  'play.waiting': 'WARTE AUF DEN GEGNER',
  'play.fireBall': 'BALL WERFEN',
  'play.fireGrenade': 'GRANATE WERFEN',
  'play.fireLeap': 'SPRINGEN UND WERFEN',
  'play.fireShield': 'SCHILD HEBEN',
  'play.fireSpring': 'AUF DIE FEDER',
  'play.fireMushroom': 'PILZ BEHALTEN',

  // --- the special button --------------------------------------------------
  'special.none': '✦ SPEZIAL: KEINS',
  'special.spent': '✦ SPEZIAL: VERBRAUCHT',
  'special.locked': '✦ SPEZIAL: GESPERRT',
  'special.off': 'SPEZIALS AUS',
  'special.chosen': '✦ {name} × {n}',

  // --- panels --------------------------------------------------------------
  'loadout.title': '🎒 AUSRÜSTUNG',
  'loadout.note': 'Was du dabeihast: was du wählst, macht deinen nächsten Wurf, und ein Schutz wird mit der Schild-Taste aufgebaut. (Taste I öffnet das hier.)',
  'intro.welcome': '{n} FÄHIGKEITEN BEREIT — ⚔ ANGRIFF WÄHLT EINE',
  'loadout.next': 'Für deinen nächsten Zug aufgehoben.',
  'loadout.ults': 'SPEZIALANGRIFFE',
  'loadout.guards': 'VERTEIDIGUNGEN',
  'loadout.howto': 'Erfolg: {name}',
  'loadout.off': 'Keine Spezialangriffe und keine Verteidigungen in diesem Modus: CLASSIC ist das Original.',
  'special.attack': '⚔ ANGRIFF',
  'special.guard': '🛡 VERTEIDIGUNG',
  'announce.round': 'RUNDE {n}',
  'announce.fight': 'KAMPF!',
  'announce.turn': 'DU BIST DRAN — {name}',
  'splash.tapForMusic': 'TIPPE FÜR MUSIK',
  'char.title': '🎨 FIGUREN',
  'char.close': '✕ SCHLIESSEN',
  'char.save': '✓ SPEICHERN',
  'char.note': 'Art und Zubehör. Ein breiteres Tier ist ein breiteres Ziel, und ein Zylinder ist ein etwas größerer Kopf: das Bild ist die Trefferzone.',
  'char.player1': 'SPIELER 1',
  'char.player2': 'SPIELER 2',
  'slot.hat': 'HUT',
  'slot.face': 'GESICHT',
  'slot.neck': 'HALS',

  'award.title': '🏆 ERFOLGE',
  'award.close': '✕ SCHLIESSEN',
  'award.progress': '🏆 ERFOLGE {n}/{total}',
  'award.rewardAntic': '+ GESTE {name}',
  'award.rewardSpecial': '+ SPEZIAL {name}',

  'rank.title': '🏆 BESTENLISTEN',
  'rank.close': '✕ SCHLIESSEN',
  'rank.name': 'DEIN NICKNAME',
    'rank.namePlaceholder': 'Gib deinen Nick ein, um zu spielen',
  'rank.online': 'ONLINE — BESTE ZUERST',
  'rank.refresh': '↻ AKTUALISIEREN',
  'rank.local': 'AUF DIESEM GERÄT',
  'rank.emptyLocal': 'Noch nichts. Spiel ein Match zu Ende, dann steht es hier.',
  'rank.emptyOnline': 'Noch nichts auf der Tafel. Sei der Erste.',
  'rank.checking': 'Wird geprüft…',

  'share.close': 'SCHLIESSEN',
  'share.generate': 'ZU EINEM SPIEL EINLADEN',
  'share.placeholder': 'Dein Code erscheint hier',
  'share.copied': 'Kopiert. Schick ihn, wem du willst.',
  'join.placeholder': 'ICH HABE EINEN CODE',
  'join.title': 'EINEM SPIEL BEITRETEN',
  'join.label': 'Spielcode',

  'lang.title': 'SPRACHE',
  'lang.note': 'Englisch ist das Original. Alles andere ist eine Übersetzung davon.',

  // --- shared match codes --------------------------------------------------
  'code.noCode': 'Erst einen Code einfügen.',
  'code.tooLong': 'Das ist viel zu lang für einen Spielcode.',
  'code.notACode': 'Das sieht nicht nach einem Spielcode aus.',
  'code.version': 'Dieser Code stammt aus einer anderen Version.',
  'code.corrupt': 'Beschädigter Code.',
  'code.mode': 'Dieser Code nennt einen Modus, den diese Version nicht hat.',

  // --- the shared board ----------------------------------------------------
  'lb.checking': 'fragt den Server…',
  'lb.online': 'geteilte Tafel, live',
  'lb.noServer': 'kein Ranking-Server hier',
  'lb.timeout': 'der Server hat nicht rechtzeitig geantwortet',

  // --- what the gorillas shout --------------------------------------------
  'bubble.fireInTheHole': 'ACHTUNG, GRANATE!',
  'bubble.leap': 'PLATZ DA!',
  'bubble.uavOnline': 'FEIND-DROHNE AKTIV',
  'bubble.headshot': 'BUMM, KOPFTREFFER!',
  'bubble.extraLife': 'EXTRALEBEN!',
  'bubble.mushroomSaved': 'DER PILZ HIELT!',
  'bubble.boomerangBack': 'ER IST ZURÜCK!',
  'bubble.boomerangLost': 'ER KAM NICHT ZURÜCK',

  // --- the caption after a kill -------------------------------------------
  'wasted.subtitle': 'Der Wind schert sich nicht um deine Pläne.',

  // --- the sky -------------------------------------------------------------
  'banner.0': 'ISST MEHR BANANEN',
  'banner.1': 'GEH AFFE!',
  'banner.2': 'BANANE FÜR PRÄSIDENT',
  'banner.3': 'DIESES BANNER LÜGT',
  'banner.4': 'SCHICKT BANANEN',
  'banner.5': 'WIEDER DANEBEN',
  'banner.6': 'GRATIS UMARMUNGEN',
  'banner.7': 'HILFE, ICH BIN IN EINEM SPIEL',
  'banner.8': 'VICE CITY — 4 MINUTEN WEG',
  'banner.9': 'LEONIDA: DAS ANDERE FLORIDA',
  'banner.10': 'ERSCHEINT 2027. WAHRSCHEINLICH.',

  // --- the splash ----------------------------------------------------------
  'tip.0': 'TIPP: DER WIND SCHERT SICH NICHT UM DEINE PLÄNE.',
  'tip.1': 'TIPP: DIE VORSCHAU RECHNET NIE MIT DEM WIND. DAS IST DER PUNKT.',
  'tip.2': 'TIPP: EINE BANANE, DIE ZURÜCKKOMMT, IST IMMER NOCH EINE BANANE.',
  'tip.3': 'TIPP: EINE GRANATE MUSS NIEMANDEN TREFFEN.',
  'tip.4': 'TIPP: WENN DER ANDERE GORILLA SCHLÄFT, SCHIESS.',
  'tip.5': 'TIPP: IRGENDWER MUSS DIESE SKYLINE AUFRÄUMEN.',

  // --- species -------------------------------------------------------------
  'species.gorilla': 'GORILLA',
  'species.chimp': 'SCHIMPANSE',
  'species.orangutan': 'ORANG-UTAN',
  'species.baboon': 'PAVIAN',
  'species.panda': 'PANDA',
  'species.bear': 'BRAUNBÄR',
  'species.rhino': 'NASHORN',
  'species.bonobo': 'BONOBO',
  'species.gibbon': 'GIBBON',
  'species.mandrill': 'MANDRILL',
  'species.hippo': 'FLUSSPFERD',
  'species.duck': 'ENTE',
  'species.frog': 'FROSCH',

  // --- accessories ---------------------------------------------------------
  'accessory.cap': 'CAP',
  'accessory.beanie': 'MÜTZE',
  'accessory.tophat': 'ZYLINDER',
  'accessory.crown': 'KRONE',
  'accessory.viking': 'WIKINGERHELM',
  'accessory.bow': 'ROSA SCHLEIFE',
  'accessory.shades': 'SONNENBRILLE',
  'accessory.patch': 'AUGENKLAYPE',
  'accessory.scarf': 'SCHAL',
  'accessory.bowtie': 'FLIEGE',
  'accessory.chain': 'GOLDKETTE',

  // --- gestures ------------------------------------------------------------
  'antic.scratch': 'KRATZEN',
  'antic.head': 'KOPF KRATZEN',
  'antic.chest': 'BRUST TROMMELN',
  'antic.wave': 'WINKEN',
  'antic.pick': 'NASE BOHREN',
  'antic.shrug': 'ACHSELZUCKEN',
  'antic.stretch': 'STRECKEN',
  'antic.shake': 'SCHÜTTELN',
  'antic.clap': 'KLATSCHT',
  'antic.flex': 'ZEIGT MUSKELN',

  // --- modes ---------------------------------------------------------------
  'mode.modern.name': 'MODERN',
  'mode.modern.blurb': 'Spezial, Gesten, Himmel und Erfolge.',
  'mode.classic.name': 'CLASSIC',
  'mode.classic.blurb': 'Kein Spezial, keine Gesten, kein Himmel, keine Erfolge.',
  'mode.demolition.name': 'ABRISS',
  'mode.demolition.blurb': 'Krater, die einen ganzen Turm fällen.',
  'mode.lunar.name': 'MONDSCHWERKRAFT',
  'mode.lunar.blurb': 'Ein Drittel der Anziehung.',
  'mode.weather.name': 'WETTER',
  'mode.weather.blurb': 'Regen, Schnee und Böen.',
  'mode.quake.name': 'ERDBEBEN',
  'mode.quake.blurb': 'Die Gebäude steigen und fallen unter deinen Füßen.',

  // --- specials ------------------------------------------------------------
  'special.flare.name': 'LEUCHTKUGEL',
  'special.flare.hint': 'Die Vorschau reicht doppelt so weit.',
  'special.heavy.name': 'SCHWER',
  'special.heavy.hint': 'Der Wind bewegt sie kaum.',
  'special.fat.name': 'BREITE LAST',
  'special.fat.hint': 'Ein viel größerer Krater.',
  'special.lunar.name': 'MONDLADUNG',
  'special.lunar.hint': 'Kein Wind. Riesiger Krater.',
  'special.grenade.name': 'GRANATE',
  'special.grenade.hint': 'Springt und knallt mit Zünder.',
  'special.drone.name': 'DROHNE',
  'special.drone.hint': 'Fliegt rüber und markiert sie.',
  'special.leap.name': 'DER SPRUNG',
  'special.leap.hint': 'Springt auf den Platz des Gegners.',
  'special.shield.name': 'SCHILD',
  'special.shield.hint': 'Stoppt einen Schuss des Gegners.',
  'social.title': 'SAG ES WEITER',
  'social.whatsapp': 'Auf WhatsApp teilen',
  'social.telegram': 'Auf Telegram teilen',
  'social.facebook': 'Auf Facebook teilen',
  'social.x': 'Auf X teilen',
  'social.instagram': 'An Instagram senden — öffnet das Teilen-Menü des Telefons',
  'social.copy': 'Link kopieren',
  'toast.copied': '🔗 Link kopiert',
  'toast.copyFailed': 'Der Browser hat das Kopieren nicht erlaubt',
  'special.pick': 'EINS WÄHLEN',
  'special.spring.name': 'FEDER',
  'special.spring.hint': 'Draufstellen und tanzen.',
  'special.mushroom.name': 'PILZ',
  'special.mushroom.hint': 'Nimmt den Schuss, der dich töten würde.',
  'toast.crateSpecial': '📦 {name} +1 — nächste Runde auch deins',
  'toast.crateTheirs': '📦 {who} nimmt {name}',
  'toast.crateLife': '❤ EXTRALEBEN — du hältst einen Treffer mehr aus',
  'toast.crateLifeTheirs': '❤ {who} nimmt ein Extraleben',
  'toast.award': '🏆 ERFOLG! {names}',
  'setup.cpu': 'CPU-SCHWIERIGKEIT',
  'setup.cpuEasy': 'LEICHT',
  'setup.cpuNormal': 'NORMAL',
  'setup.cpuHard': 'SCHWER',
  'rotate.title': 'DREH DAS TELEFON',
    'rotate.body': 'Gespielt wird quer: dreh das Telefon auf die Seite, um weiterzuspielen.',
  'setup.duel': 'WIE IHR ZWEI SPIELT',
  'duel.code': '🔗 JEDER AN PC / TELEFON',
  'duel.hotseat': '⌨️ DERSELBE COMPUTER',
  'share.waiting': 'Schick ihnen den Code. Sie schicken einen zurück.',
  'share.invite': 'Kopier den Code und schick ihn, wem du einladen willst.',
  'share.joined': 'Du bist drin. Du wirfst zuerst.',
  'share.roomOpen': 'Der Raum ist offen: dieser Code ist die Tür, und ihr spielt live, ohne Codes weiterzureichen.',
  'share.roomBack': 'Dein Gegner ist da.',
  'share.roomGone': 'Dein Gegner ist raus. Der Raum bleibt offen und sein Platz ist frei.',
  'share.roomLost': 'Die Verbindung ist weg. Die Partie läuft auf diesem Gerät weiter.',
  'code.inviteLength': 'Eine Einladung hat 8 Zeichen, 4 und 4.',
  'code.inviteLetters': 'In diesem Code steht ein Zeichen, das nicht vorkommen kann.',
  'code.inviteCheck': 'Dieser Code geht nicht auf: prüf einen Buchstaben.',
  'special.ball.name': 'DER BALL',
  'special.ball.hint': 'Manchmal ist es ein Ball.',
  'special.boomerang.name': 'BUMERANG',
  'special.boomerang.hint': 'Kommt in deine Hand zurück, ohne Ladung zu kosten.',
  'toast.ball': '{icon} {name}!',
  'ball.basket': 'BASKETBALL',
  'ball.football': 'FUSSBALL',
  'ball.rugby': 'RUGBYBALL',
  'ball.tennis': 'TENNISBALL',

  // --- achievements --------------------------------------------------------
  'ach.first-blood.name': 'ERSTES BLUT',
  'ach.first-blood.hint': 'Triff mit deiner ersten Banane.',
  'ach.round-won.name': 'RUNDE GEWONNEN',
  'ach.round-won.hint': 'Gewinn eine Runde.',
  'ach.butterfingers.name': 'BUTTERFINGER',
  'ach.butterfingers.hint': 'Sich selbst zu treffen zählt auch.',
  'ach.sharpshooter.name': 'SCHARFSCHÜTZE',
  'ach.sharpshooter.hint': 'Triff dreimal hintereinander.',
  'ach.match-won.name': 'SPIEL GEWONNEN',
  'ach.match-won.hint': 'Gewinn ein Spiel.',
  'ach.cpu-slayer.name': 'CPU-BEZWINGER',
  'ach.cpu-slayer.hint': 'Gewinn ein Spiel gegen die CPU.',
  'ach.moon-shot.name': 'MONDSCHUSS',
  'ach.moon-shot.hint': 'Lass eine Banane vor dem Mond vorbeiziehen.',
  'ach.sky-watcher.name': 'HIMMELSBEOBACHTER',
  'ach.sky-watcher.hint': 'Erwisch drei verschiedene Dinge am Himmel.',
  'ach.flawless.name': 'MAKELOS',
  'ach.flawless.hint': 'Gewinn ein Spiel ohne eine einzige Runde abzugeben.',
  'ach.veteran.name': 'VETERAN',
  'ach.veteran.hint': 'Gewinn drei Spiele.',
  'ach.thrower.name': 'WERFER',
  'ach.thrower.hint': 'Wirf 50 Bananen.',
  'ach.rounds-10.name': 'ZEHN RUNDEN',
  'ach.rounds-10.hint': 'Gewinn zehn Runden.',
  'ach.sharpshooter-plus.name': 'ADLERAUGE',
  'ach.sharpshooter-plus.hint': 'Triff sechsmal hintereinander.',
  'ach.moon-3.name': 'ASTROPHYSIKER',
  'ach.moon-3.hint': 'Lass dreimal eine Banane vor dem Mond vorbeiziehen.',
  'ach.cpu-3.name': 'AUFGEDREHT',
  'ach.cpu-3.hint': 'Schlag die CPU dreimal.',
  'ach.flawless-3.name': 'UNANTASTBAR',
  'ach.flawless-3.hint': 'Gewinn drei Spiele ohne eine Runde abzugeben.',
  'ach.veteran-2.name': 'LEGENDE',
  'ach.veteran-2.hint': 'Gewinn fünf Spiele.',
  'ach.scavenger.name': 'PLÜNDERER',
  'ach.scavenger.hint': 'Öffne fünf Kisten.',
  'ach.wall.name': 'DIE MAUER',
  'ach.wall.hint': 'Hebe fünfmal den Schild.',
  'ach.arsenal.name': 'ARSENAL',
  'ach.arsenal.hint': 'Benutze sechs verschiedene Spezials.',
  'ach.bare-handed.name': 'MIT BLOSSEN HÄNDEN',
  'ach.bare-handed.hint': 'Gewinne eine Partie, ohne etwas auszugeben.',
  'ach.room-won.name': 'LIVE',
  'ach.room-won.hint': 'Gewinne eine Partie in einem Raum.',
  'ach.room-3.name': 'NACHBARSCHAFT',
  'ach.room-3.hint': 'Gewinne drei Partien in Räumen.',
  'ach.by-mail.name': 'PER POST',
  'ach.by-mail.hint': 'Gewinne ein Duell per Code.',
  'ach.boomerang-back.name': 'DIE RÜCKKEHR',
  'ach.boomerang-back.hint': 'Fang deinen eigenen Bumerang dreimal.',
};
